


































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponenteBackofficeEnviaCodigoUnicoMaterial extends Vue {
  $refs!: { formCodigoUnicoMaterial: any }

  @Prop({ default: false }) disabled: boolean

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  enviaCodigoUnicoMaterialRules: any = {
    valid: false,
    codigoUnicoMaterial: [v => !!v || 'Campo obrigatório'],
  }

  get getCodigoUnicoMaterial() {
    const { codigoUnicoMaterial } = this.getBackofficeGlobalStore.solicitacao
    return codigoUnicoMaterial || ''
  }

  set getCodigoUnicoMaterial(value: string) {
    this.getBackofficeGlobalStore.setCodigoUnicoMaterial(value)
  }
}
